import { SwipeableDrawer, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import React, { useEffect, useRef, useState } from 'react';

import PriceDetails from '@/components/PriceDetails';
import FlexRowBetween from '../FlexRowBetween';
import { TBottomContainerProps } from './type';
import { get } from 'lodash';
import { pr } from '@/utils/pxToRem';
import PaymentLoadingModel from '../PaymentLoadingModel';
import { useRouter } from 'next/router';
import { style } from '@/styles/globals';
import PriceDetailsApi from '../PriceDetailsApi';

const Container = styled('div')(({ theme }) => ({
  background: theme.palette.white,
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  zIndex: 1,
  boxSizing: 'border-box',
  padding: theme.palette.medium,
  borderTopLeftRadius: theme.palette.borderRadius?.popup,
  borderTopRightRadius: theme.palette.borderRadius?.popup,
  overflow: 'hidden',
  boxShadow: theme.palette.boxShadow?.boxShadow02,
  ':before': {
    content: '" "',
    width: '44px',
    height: '5px',
    position: 'absolute',
    background: theme.palette.black7,
    left: '50%',
    top: '0.5rem',
    transform: 'translateX(-50%)',
    borderRadius: theme.palette.borderRadius?.badge,
  },
}));

export const BottomContainer: React.FunctionComponent<TBottomContainerProps> = ({
  priceDetailsObj, isLoading, listAirline, handleNextPage, isPayment, children, setOpenPriceDetailsDrawer, openPriceDetailsDrawer, isDisabled, isDepart,
  isDataFromApi, orderData,
}) => {
  const [placeholderHeight, setPlaceholderHeight] = useState(0);
  const [open, setOpen] = React.useState(false);
  const { query } = useRouter();

  const ref = useRef(null);

  useEffect(() => {
    const height = get(ref.current, 'clientHeight') || 0;
    if (height) {
      setPlaceholderHeight(height);
    }
  }, []);
  const handleClickBtn = () => {
    if (isLoading && query?.id?.length === 0) {
      setOpen(true);
      return;
    }
    if (handleNextPage) {
      setTimeout(() => {
        handleNextPage();
      }, 100);
    }
  };

  useEffect(() => {
    if (!query || !query.id) return;
    if (!isLoading && open && query && query?.id?.length > 0) {
      if (handleNextPage) {
        handleNextPage();
      }
      setOpen(false);
    }
  }, [isLoading, query]);
  const PriceDetailsComponent = isDataFromApi ? PriceDetailsApi : PriceDetails;
  return (
    <>
      <Container ref={ref}>
        <FlexRowBetween>
          {children}
          <LoadingButton
            disabled={isDisabled}
            loading={false}
            variant="contained"
            color="primary"
            onClick={handleClickBtn}
            sx={{
              width: '140px',
              color: (theme) => theme.palette.white,
              height: '44px',
              background: `${style.color.product3}!important`,
              // opacity: isLoading ? '20%' : '',
            }}
          >
            <Typography
              color="white4"
              variant="contentBold"
              sx={{ maxWidth: '80px' }}
            >
              {isPayment ? 'Thanh toán' : isDepart ? 'Chọn vé chiều về' : 'Tiếp tục'}
            </Typography>
          </LoadingButton>
        </FlexRowBetween>
        <SwipeableDrawer
          anchor="bottom"
          open={openPriceDetailsDrawer || false}
          onOpen={() => {}}
          onClose={() => setOpenPriceDetailsDrawer && setOpenPriceDetailsDrawer(false)}
          PaperProps={{
            style: {
              borderTopLeftRadius: '16px',
              borderTopRightRadius: '16px',
            },
          }}
        >
          {priceDetailsObj ? (
            <PriceDetailsComponent
              orderData={orderData}
              priceDetailsObj={priceDetailsObj}
              isPayment={isPayment}
              flightPriceDiff={priceDetailsObj.flightPriceDiff}
              flightArr={priceDetailsObj.flightArr}
              passenger={priceDetailsObj.passenger}
              baggagePrice={priceDetailsObj.totalBaggagePrice}
              baggagePriceDepart={priceDetailsObj?.departBaggagePrice || 0}
              baggagePriceReturn={priceDetailsObj?.returnBaggagePrice || 0}
              discountAmount={priceDetailsObj.totalDiscountAmount}
              onCloseButton={() => setOpenPriceDetailsDrawer && setOpenPriceDetailsDrawer(false)}
              onNextButton={handleNextPage}
              isDepart={isDepart}
            />
          ) : null}
        </SwipeableDrawer>
      </Container>
      {isPayment && (
        <PaymentLoadingModel
          setOpen={setOpen}
          listAirline={listAirline || []}
          open={open}
        />
      )}
    </>
  );
};
